import QuestCreateUpdate from "./QuestCreateUpdate.jsx";
import ViewQuestStop from "./ViewQuestStop.jsx";
import ListQuest from "./ListQuest.jsx";

export default {
  QuestCreateUpdate,
  ViewQuestStop,
  ListQuest
}
